import React from 'react';
import { componentService } from 'js/services/component.service';

export const LottoWidget = React.lazy(() => import(/* webpackChunkName: "lotto-widget" */ './LottoWidget'));

// <hub2-lotto-widget widgetname="lotto-bet-history"></hub2-lotto-widget>
componentService.registerWebContentComponents({ LottoWidget });
